import { useRouter } from "next/router";

import { Container, List, ListItem } from "./Filter.styled";

import { FaqCategory } from "types/storyblok";

function Filter({
    filters = []
}: {
    filters: Array<FaqCategory>;
}): JSX.Element {
    const router = useRouter();
    const categoryQuery = router.query?.categorie as string;

    function setFilter(filter: string | null) {
        if (filter === null) {
            router.push({ pathname: router.pathname, query: {} });
        } else {
            router.push({
                pathname: router.pathname,
                query: { categorie: filter }
            });
        }
    }

    return (
        <Container>
            <p>Filter op</p>
            <List>
                <ListItem
                    aria-label="alle vragen tonen"
                    isActive={!categoryQuery}
                    onClick={() => {
                        setFilter(null);
                    }}
                >
                    Alle
                </ListItem>
                {filters.map(item => (
                    <ListItem
                        aria-label={`filter op ${item.name}`}
                        isActive={categoryQuery === item.value}
                        key={JSON.stringify(item)}
                        onClick={() => {
                            setFilter(item.value);
                        }}
                    >
                        {item.name}
                    </ListItem>
                ))}
            </List>
        </Container>
    );
}

export default Filter;
